import React, { useState } from "react";
import IMAGES from "../../../constant/IMAGES";
import TextHeader from "../../TextHeader";

const dataFAQs = [
  {
    question: "Ứng dụng này cung cấp những tính năng gì?",
    answer: (
      <>
        <p className="text-sm/[25px] md:text-xl/[34px] text-white">
          + <b className="font-semibold">Kiểm tra phong thủy nhà ở:</b> Sử dụng
          bản đồ, hình ảnh hoặc mô tả để phân tích phong thủy cho ngôi nhà của
          bạn. <br />{" "}
          <b className="font-semibold">+ Thiết kế nhà theo phong thủy:</b> Gợi ý
          cách bố trí nội thất, lựa chọn màu sắc và vật dụng hợp phong thủy.{" "}
          <br /> <b className="font-semibold"> + Xem ngày tốt xấu:</b> Tra cứu
          ngày giờ đẹp cho các hoạt động quan trọng như khai trương, cưới hỏi,
          đi du lịch,... <br />{" "}
          <b className="font-semibold">+ Xem bói tử vi: </b> Dự đoán vận mệnh,
          tài lộc, sức khỏe dựa trên thông tin cá nhân như ngày tháng năm sinh,
          giờ sinh.
          <br />{" "}
          <b className="font-semibold">
            + Cung cấp các kiến thức phong thủy:
          </b>{" "}
          Chia sẻ thông tin về các nguyên tắc phong thủy, các biểu tượng may mắn
          và cách áp dụng trong cuộc sống.
          <br />
          <b className="font-semibold">
            + Xem gia phả.
            <br />
            + Tập tục nhang đèn. <br /> + Kết nối với chuyên gia.
          </b>
        </p>
      </>
    ),
  },
  {
    question: "Ứng dụng này hoạt động như thế nào?",
    answer: (
      <>
        <p className="text-sm/[25px] md:text-xl/[34px] text-white">
          Ứng dụng sử dụng các thuật toán phong thủy kết hợp với dữ liệu về ngày
          tháng năm sinh, vị trí địa lý và thông tin cá nhân khác để đưa ra các
          lời tư vấn phân tích và dự đoán.
        </p>
      </>
    ),
  },
  {
    question: "Ứng dụng này có chính xác không?",
    answer: (
      <>
        <p className="text-sm/[25px] md:text-xl/[34px] text-white">
          Mức độ chính xác của ứng dụng phụ thuộc vào nhiều yếu tố như chất
          lượng dữ liệu đầu vào, độ phức tạp của thuật toán và cách thức áp dụng
          phong thủy trong thực tế. Do đó, nên sử dụng kết quả từ ứng dụng này
          như một tài liệu tham khảo và kết hợp với các nguồn thông tin khác để
          đưa ra quyết định phù hợp.
        </p>
      </>
    ),
  },
  {
    question: "Ứng dụng này có an toàn không?",
    answer: (
      <>
        <p className="text-sm/[25px] md:text-xl/[34px] text-white">
          Mức độ an toàn của ứng dụng phụ thuộc vào uy tín của nhà phát triển và
          các chính sách bảo mật thông tin của họ. Nên tải ứng dụng từ các nguồn
          uy tín như Google Play Store hoặc App Store để đảm bảo an toàn cho
          thiết bị và thông tin cá nhân.
        </p>
      </>
    ),
  },
  {
    question: "Ứng dụng này có miễn phí không?",
    answer: (
      <>
        <p className="text-sm/[25px] md:text-xl/[34px] text-white">
          Hầu hết các ứng dụng phong thủy đều cung cấp phiên bản miễn phí với
          các tính năng cơ bản. Tuy nhiên, một số tính năng nâng cao có thể yêu
          cầu thanh toán để sử dụng.
        </p>
      </>
    ),
  },
  {
    question: "Ai nên sử dụng ứng dụng này?",
    answer: (
      <>
        <p className="text-sm/[25px] md:text-xl/[34px] text-white">
          - Bất kỳ ai quan tâm đến phong thủy và muốn áp dụng các nguyên tắc này
          vào cuộc sống đều có thể sử dụng ứng dụng này. <br /> - Ứng dụng này
          đặc biệt hữu ích cho: <br className="pl-4 block" /> + Người mới bắt
          đầu tìm hiểu về phong thủy. <br className="pl-4 block" /> + Chủ nhà
          muốn cải thiện phong thủy cho ngôi nhà của mình.{" "}
          <br className="pl-4 block" /> + Doanh nghiệp muốn tìm ngày tốt để khai
          trương hoặc thực hiện các hoạt động quan trọng.
        </p>
      </>
    ),
  },
];

const SectionFAQs = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(0);
  const [isShow, setIsShow] = useState(false);
  return (
    <div
      className="flex flex-col gap-[92px] mb-20 xl:scroll-m-52 scroll-m-32"
      id="hoi-dap"
    >
      <TextHeader text="Hỏi đáp" />
      <div className="xl:flex hidden items-center w-full">
        <div
          className="flex flex-col gap-[14px] w-1/2 relative z-[1]"
          style={{ transform: "translateY(20px)" }}
          data-aos="fade-right"
          data-aos-duration="800"
        >
          {dataFAQs.map((item, index) => (
            <div
              key={index}
              className={`flex gap-8 group items-center px-5 py-3 rounded-[13.33px] h-fit overflow-hidden justify-between relative z-[2] transition-all duration-300 cursor-pointer ${
                activeIndex === index
                  ? "gradient-borderFull bg-[linear-gradient(180deg,#292A2C_0%,#000000_100%)] before:p-[1.33px]"
                  : "bg hover:bg-[linear-gradient(180deg,#292A2C_0%,#000000_100%)]"
              }`}
              onClick={() => setActiveIndex(index)}
            >
              <span
                className={`absolute top-0 left-0 w-full h-full bg-overlay ${
                  activeIndex === index
                    ? "opacity-80"
                    : "opacity-0 group-hover:opacity-80"
                } object-cover`}
              />
              <div className="flex gap-[30px] items-center">
                <img src={IMAGES.dot} alt="" />
                <p
                  className={`text-xl/[34px] transition-all duration-300 ${
                    activeIndex === index
                      ? "text-goldGradient font-bold"
                      : "text-white group-hover:text-goldGradient group-hover:font-bold"
                  }`}
                >
                  {item.question}
                </p>
              </div>
              <img
                src={
                  activeIndex === index ? IMAGES.iconArrowNo : IMAGES.iconArrow
                }
                alt="arrow"
                className=""
              />
            </div>
          ))}
        </div>
        {dataFAQs.map(
          (item, index) =>
            activeIndex === index && (
              <div className="bg rounded-[21.33px] w-[55%] min-h-[600px] -translate-x-20">
                <div className="flex justify-center aspect-[863/648] min-h-[600px] w-full flex-col gap-8 bg-bgFAQs position-relative before:p-[1.33px] pl-[15%] pr-[5%] py-[5%] item-center !rounded-[21.33px] before:rounded-[21.33px] shadow-[0px_6px_0px_0px_#FFFFFF33]">
                  <h1
                    className="text-goldGradient text-2xl font-bold"
                    data-aos="fade-right"
                    data-aos-duration="800"
                  >
                    {item.question}
                  </h1>
                  <p
                    data-aos="fade-right"
                    data-aos-duration="800"
                    className="text-justify"
                  >
                    {item.answer}
                  </p>
                </div>
              </div>
            )
        )}
      </div>

      <div className="flex xl:hidden w-full flex-col gap-[14px] relative">
        {dataFAQs.map((item, index) => (
          <div
            key={index}
            className={`bg-gradient-to-b from-[#292A2C] to-[#000000] overflow-hidden ease-linear before:!p-[1px] gradient-borderFull rounded-[5.42px] p-5 gap-3 md:gap-6 flex flex-col cursor-pointer transition-all duration-700 ${
              activeIndex === index ? "max-h-[700px]" : "max-h-[66px] h-fit"
            }`}
            onClick={() => {
              setActiveIndex(index);
              setIsShow((prev) => !prev);
            }}
          >
            <div
              className={`flex gap-2 items-center justify-between transition-all duration-300`}
            >
              <span
                className={`absolute top-0 left-0 w-full h-full pointer-events-none ${
                  activeIndex === index ? "opacity-80 bg-overlay" : ""
                } transition-all duration-300 ease-linear`}
              />
              <div className="flex gap-3 md:gap-[30px] items-center">
                <img src={IMAGES.dot} alt="" />
                <p
                  className={`md:text-xl/[34px] text-base/[20px] ${
                    activeIndex === index
                      ? "text-goldGradient font-bold"
                      : "text-white"
                  }`}
                >
                  {item.question}
                </p>
              </div>
              <img
                src={IMAGES.iconArrowNo}
                alt="arrow"
                className={`${
                  activeIndex === index ? "rotate-90" : "-rotate-90"
                } md:size-8 size-5`}
              />
            </div>
            <img
              src={IMAGES.line}
              alt="line"
              className={activeIndex === index ? "opacity-100 block" : "hidden"}
            />

            <p
              className={`flex justify-center flex-col gap-8 pb-4 transition-all text-justify text-sm sm:text-xl duration-300 ease-linear ${
                activeIndex === index ? "opacity-100 block" : "opacity-0"
              }`}
            >
              {item.answer}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SectionFAQs;
